<template>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="items"
    :loading="loading"
    :options.sync="table"
    :server-items-length="totalItems"
    :footer-props="footerProps"
    :items-per-page.sync="table.itemsPerPage"
    must-sort
    :show-select="processType === 'bulk_upload'"
    item-key="id"
  >
    <template #item="{ item, isSelected, select }">
      <tr :class="{ 'selected-row': isSelected }">
        <td v-if="processType === 'bulk_upload'">
          <v-checkbox
            :input-value="isSelected"
            hide-details
            dense
            @click="select(!isSelected)"
          ></v-checkbox>
        </td>
        <td>
          <template v-if="processType === 'bulk_upload'">
            <a class="text-decoration-underline" @click="$emit('open-form', item)">
              {{ formatTitle(item) | humanize }}
            </a>
          </template>
          <template v-else>
            <span class="font-weight-medium">
              {{ item.source_tree_id }}
            </span>
          </template>
        </td>
        <td>
          <template v-if="processType === 'bulk_upload'">
            <a class="text-decoration-underline text-break" @click="$emit('open-form', item)">
              {{ item.name }}
            </a>
          </template>
          <template v-else>
            <span class="font-weight-medium">
              {{ item.target_tree_id }}
            </span>
          </template>
        </td>
        <td>
          <template v-if="processType === 'bulk_upload'">
            <a class="text-decoration-underline text-break" @click="$emit('open-form', item)">
              {{ item.created_by }}
            </a>
          </template>
          <template v-else>
            <span class="font-weight-medium">
              {{ item.target_localization }}
            </span>
          </template>
        </td>
        <td>{{ item.status | humanize }}</td>
        <!-- <td v-if="type === 'video'">
          <v-btn
            v-if="item.namespace === 'video/proposals/rule'"
            icon
            @click="$emit('open-discoveries', item.id)"
          >
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-btn>
        </td> -->
        <td>
          <template v-if="processType === 'bulk_upload'">
            <a class="text-decoration-underline text-break" @click="$emit('open-form', item)">
              {{ item.updated_at | time }}
            </a>
          </template>
          <template v-else>
            <v-btn
              :loading="downloadingItemId === item.id"
              :disabled="downloadingItemId === item.id"
              size="large"
              color="light blue"
              class="mb-3 mt-3 px-4 py-3 font-medium"
              prepend-icon="mdi-download"
              elevation="3"
              @click="
                downloadData(
                  item.id,
                  item.source_tree_id,
                  item.target_tree_id,
                  item.target_localization,
                )
              "
            >
              <template v-if="downloadingItemId === item.id">
                <v-icon left class="mr-2 animate-spin">mdi-loading</v-icon>
                DOWNLOADING...
              </template>
              <template v-else>
                DOWNLOAD CSV
              </template>
            </v-btn>
          </template>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import HTTP from '@/api/ant';
import { TableMixin } from '@nielsen-media/ui-toolkit-vue-api';

export default {
  name: 'BulkReviewsTable',
  components: {},
  mixins: [TableMixin],
  props: {
    id: {
      type: Number,
      default: null,
      required: false,
    },
    type: {
      type: String,
      default: '',
      required: false,
    },
    processType: {
      type: String,
      required: true,
      validator: value => ['bulk_upload', 'rule_import'].includes(value),
    },
  },
  emits: ['open-form', 'selection-changed'],
  data: () => ({
    form: {
      show: false,
      id: null,
      namespace: null,
    },
    downloadingItemId: null,
    downloadError: null,
    downloadedEncodedData: null,
    selected: [],
    table: {
      sortBy: ['updated_at'],
      sortDesc: [true],
    },
    bulkImportHeaders: [
      { text: 'Type', sortable: false, value: 'item_kind' },
      { text: 'Name', sortable: false, value: 'name' },
      { text: 'Created By', sortable: false, value: 'created_by' },
      { text: 'Status', sortable: false, value: 'status' },
      { text: 'Updated At', sortable: true, value: 'updated_at' },
    ],
    ruleImportHeaders: [
      { text: 'Source Tree Id', sortable: false, value: 'source_tree_id' },
      { text: 'Target Tree Id', sortable: false, value: 'target_tree_id' },
      { text: 'Target Localization', sortable: false, value: 'target_localization' },
      { text: 'Status', sortable: true, value: 'status' },
      { text: 'Download CSV', sortable: false, value: 'download_button' },
    ],
  }),
  computed: {
    headers() {
      return this.processType === 'rule_import' ? this.ruleImportHeaders : this.bulkImportHeaders;
    },
  },
  watch: {
    selected(val) {
      this.$emit('selection-changed', val);
    },
  },
  // created() {
  //   if (this.type === 'video') {
  //     const discoveryColumn = { text: 'Discoveries', sortable: false, value: 'video' };
  //     this.headers.splice(2, 0, discoveryColumn);
  //   }
  // },
  methods: {
    tableFetch() {
      this.loading = true;
      this.paginateTableData(
        HTTP,
        this.processType === 'bulk_upload'
          ? `/${this.type}/proposals?sort=updated_at&filter[bulk_upload_process_id]=${this.id}`
          : `/rule_import_result?bulk_upload_process_id=${this.id}`,
      ).finally(() => {
        this.loading = false;
      });
    },
    openForm(form) {
      this.$emit('open-form', form);
    },
    formatTitle(item) {
      return item.item_kind || '';
    },
    downloadData(id, source_tree_id, target_tree_id, target_localization) {
      this.downloadingItemId = id;
      this.downloadError = null;

      HTTP.get(`rule_import_result/${id}/download_csv`)
        .then(response => {
          this.downloadedEncodedData = response.data.file_content;
          this.decodeAndDownload(
            this.downloadedEncodedData,
            source_tree_id,
            target_tree_id,
            target_localization,
          );
          this.$flash('success', 'File downloaded successfully');
        })
        .catch(err => {
          this.downloadError = err.toString();
          this.$flash('error', err.toString());
        })
        .finally(() => {
          this.downloadingItemId = null;
        });
    },
    decodeAndDownload(encodedData, source_tree_id, target_tree_id, target_localization) {
      try {
        // Decode the base64 string
        const decodedData = atob(encodedData);
        const blob = new Blob([decodedData], { type: 'text/csv' });

        // Create a download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `bulk_review_proposals_${source_tree_id}_${target_tree_id}_${target_localization}.csv`,
        );

        // Append to the document, click, and remove
        document.body.appendChild(link);
        link.click();

        // Clean up
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } catch (e) {
        this.error = e.toString();
        throw new Error('Failed to process the download');
      }
    },
  },
};
</script>

<style scoped>
.selected-row {
  background-color: rgba(33, 150, 243, 0.08) !important;
}

.v-data-table >>> .v-data-table__wrapper {
  max-height: 400px;
  min-height: 200px;
  overflow-y: auto;
  width: 890px;
}
</style>
